<template>
  <div>
    <vxe-grid
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      size="small"
      ref="table"
      row-id="materialCode"
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize
      }"
      :radio-config="{ highlight: true ,trigger: 'row'}"
      :checkbox-config="{
        highlight: true,
        reserve: true
      }"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:defaultImageUrl="{ row }">
        <el-image
          :src="
            row.defaultImageCode
              ? $osscdn(row.defaultImageCode)
              : '/image/static/img/nopic.jpg'
          "
          style="width:100px; height:66px"
        >
          <div slot="error" class="image-slot">
            <img
              src="/image/static/img/nopic.jpg"
              style="width: 100px; height: 66px"
            />
          </div>
        </el-image>
      </template>
      <template v-slot:materialNameInfo="{ row }">
        <span>{{ row.materialNo }}</span>
        <br />
        <span>{{ row.materialName }}</span>
        <br />
        <span>{{ row.materialNameEn }}</span>
      </template>
      <template v-slot:displayName="{ row }">
        <span>{{ row.displayName }}</span>
        <br />
        <span>{{ row.displayNameEn }}</span>
      </template>
      <template v-slot:moqInfo="{ row }">
        {{ row.moq }} {{ row.moqUnit }}
      </template>
      <template v-slot:priceInfo="{ row }">
        {{ row.price }} {{ row.v_currencyUnit }}
      </template>
      <template v-slot:displayMaterial="{ row }">
        {{ row.mainMaterialCategoryName }}/{{ row.detailMaterialCategoryName }}
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">{{ $l('INDEX.tips_no_data') || '暂无数据！' }}</p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
export default {
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { default: null, type: Object },
    loading: { type: Boolean, default: false },
    type: String
  },
  data() {
    return {
      tableHeight: 600,
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form'
        },
        refresh: {
          query: () => this.$emit('reload')
        }
      },
      tableColumns: [
        {
          field: 'seq',
          width: 50,
          align: 'center',
          fixed: 'left',
          type: 'seq'
        },
        {
          field: 'checkbox',
          width: 40,
          align: 'center',
          fixed: 'left',
          type: 'checkbox',
          visible: this.type === 'checkbox'
        },
        {
          field: 'radio',
          width: 40,
          align: 'center',
          fixed: 'left',
          type: 'radio',
          visible: this.type === 'radio'
        },
        {
          field: 'defaultImageUrl',
          width: 120,
          title: this.$l('INDEX.form_label_picture') || '图片',
          align: 'center',
          fixed: 'left',
          slots: { default: 'defaultImageUrl' }
        },
        {
          title: this.$l('INDEX.material_choose_material_name') || '物料名称',
          field: 'materialNameInfo',
          minWidth: 230,
          align: 'left',
          headerAlign: 'left',
          showHeaderOverflow: 'title',
          slots: { default: 'materialNameInfo' }
        },
        {
          title: this.$l('INDEX.material_choose_display_name') || '物料描述',
          field: 'displayName',
          minWidth: 450,
          align: 'left',
          headerAlign: 'left',
          showHeaderOverflow: 'title',
          slots: { default: 'displayName' }
        },
        {
          title:
            this.$l('INDEX.material_choose_detail_category_name') || '物料分类',
          field: 'detailMaterialCategoryName',
          minWidth: 150,
          align: 'left',
          headerAlign: 'left',
          showHeaderOverflow: 'title',
          slots: { default: 'displayMaterial' }
        },
        {
          title: this.$l('INDEX.material_choose_supplier') || '厂商',
          field: 'scmName',
          minWidth: 200,
          align: 'left',
          headerAlign: 'left',
          showHeaderOverflow: 'title'
        },
        {
          title:
            this.$l('INDEX.material_choose_supplier_item_no') || '工厂样品编号',
          field: 'factoryItemNo',
          minWidth: 160,
          align: 'left',
          headerAlign: 'left',
          showHeaderOverflow: 'title'
        },
        {
          title: this.$l('INDEX.material_choose_moq_info') || '起订量',
          field: 'moq',
          minWidth: 100,
          align: 'left',
          headerAlign: 'left',
          showHeaderOverflow: 'title',
          slots: { default: 'moqInfo' }
        },
        {
          title: this.$l('INDEX.material_choose_price_info') || '单价',
          field: 'price',
          minWidth: 100,
          align: 'left',
          headerAlign: 'left',
          showHeaderOverflow: 'title',
          slots: { default: 'priceInfo' }
        },
        {
          title: this.$l('INDEX.table_label_remarks') || '备注说明',
          field: 'remarks',
          minWidth: 240,
          align: 'left',
          headerAlign: 'left',
          showHeaderOverflow: 'title'
        }
      ]
    }
  },
  methods: {
    choiceData() {
      if (this.type === 'checkbox') {
        return this.getCheckboxRecords()
      }
      if (this.type === 'radio') {
        return this.getRadioRecord()
      }
    },
    getRadioRecord() {
      const data = this.$refs.table.getRadioRecord()
      if (!data) {
        this.$message({
          showClose: true,
          message:
            this.$l('INDEX.table_label_pl_select_add_data') ||
            '请选择需要添加的数据',
          type: 'warning'
        })
        return
      }
      return data
    },
    getCheckboxRecords() {
      const data = this.$refs.table
        .getCheckboxRecords()
        .concat(this.$refs.table.getCheckboxReserveRecords())
      if (!data.length) {
        this.$message({
          showClose: true,
          message:
            this.$l('INDEX.table_label_pl_select_add_data') ||
            '请选择需要添加的数据',
          type: 'warning'
        })
        return
      }
      return data
    }
  }
}
</script>
